"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.approveAllLeaderApplies = approveAllLeaderApplies;
exports.approveLeaderApply = approveLeaderApply;
exports.approveLeaderWithdraw = approveLeaderWithdraw;
exports.approvePromoterApply = approvePromoterApply;
exports.changeLeaderAgent = changeLeaderAgent;
exports.deleteLeaderApplyRule = deleteLeaderApplyRule;
exports.deleteRegionAgent = deleteRegionAgent;
exports.disableLeaderUserVerifyLimit = disableLeaderUserVerifyLimit;
exports.disablePromoter = disablePromoter;
exports.disableRegionAgent = disableRegionAgent;
exports.enableFromQueue = enableFromQueue;
exports.enablePromoter = enablePromoter;
exports.getAgentBills = getAgentBills;
exports.getAgentList = getAgentList;
exports.getAllianceConfig = getAllianceConfig;
exports.getApplicantConditions = getApplicantConditions;
exports.getCommissionList = getCommissionList;
exports.getDistributionConfig = getDistributionConfig;
exports.getLeaderApplyList = getLeaderApplyList;
exports.getLeaderApplyMetrics = getLeaderApplyMetrics;
exports.getLeaderApplyRules = getLeaderApplyRules;
exports.getLeaderBills = getLeaderBills;
exports.getLeaderGrants = getLeaderGrants;
exports.getLeaderList = getLeaderList;
exports.getLeaderMemberConsume = getLeaderMemberConsume;
exports.getLeaderUserVerifyLimitList = getLeaderUserVerifyLimitList;
exports.getLeaderWithdrawCard = getLeaderWithdrawCard;
exports.getLeaderWithdrawList = getLeaderWithdrawList;
exports.getMerchantOverview = getMerchantOverview;
exports.getPendingRisks = getPendingRisks;
exports.getPlatformDistributionProducts = getPlatformDistributionProducts;
exports.getPointsAccounts = getPointsAccounts;
exports.getPointsLedger = getPointsLedger;
exports.getPromoterApplies = getPromoterApplies;
exports.getPromoters = getPromoters;
exports.getRegionAgent = getRegionAgent;
exports.getRegionAssignments = getRegionAssignments;
exports.getRegionQueue = getRegionQueue;
exports.getShareTraceConsumers = getShareTraceConsumers;
exports.getShareTraceOrders = getShareTraceOrders;
exports.getShareTraces = getShareTraces;
exports.getUserBrief = getUserBrief;
exports.getVerifyRecords = getVerifyRecords;
exports.grantLeader = grantLeader;
exports.handleRisk = handleRisk;
exports.handoverRegionAgent = handoverRegionAgent;
exports.markLeaderWithdrawPaid = markLeaderWithdrawPaid;
exports.openRegionAgent = openRegionAgent;
exports.quickApprovePromoterApply = quickApprovePromoterApply;
exports.rejectLeaderWithdraw = rejectLeaderWithdraw;
exports.rejectPromoterApply = rejectPromoterApply;
exports.revokeLeaderGrant = revokeLeaderGrant;
exports.revokeLeaderIdentity = revokeLeaderIdentity;
exports.saveDistributionConfig = saveDistributionConfig;
exports.saveLeaderApplyRule = saveLeaderApplyRule;
exports.saveLeaderUserVerifyLimit = saveLeaderUserVerifyLimit;
exports.searchUser = searchUser;
exports.togglePlatformDistributionProduct = togglePlatformDistributionProduct;
exports.unbindLeaderAgent = unbindLeaderAgent;
exports.updateAllianceConfig = updateAllianceConfig;
exports.updateRegionAgent = updateRegionAgent;
exports.vetoLeaderApply = vetoLeaderApply;
var _request = _interopRequireDefault(require("@/utils/request"));
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 校园收益联盟 API（平台端）
 *
 * 后端在 tjMall-alliance 模块，经网关 /alliance 路由转发（StripPrefix=1），
 * 所以这里的 url 要带上后端自己的 /api 前缀。
 *
 * 鉴权沿用平台端现有登录态：request.js 会把 `Authori-zation` 头带上，
 * 联盟侧的 MallTokenResolver 认得 platform 前缀的 Redis 令牌，不需要额外换票。
 *
 * 响应：联盟的成功码同样是 200，拦截器已经把 data 解出来了，页面拿到的就是业务数据。
 */

var baseURL = _settingMer.default.apiBaseURL6;

/*
 * 没配 VUE_APP_BASE_API6 时 settingMer 会 fallback 到 location.origin，
 * 请求就打到前端自己的 dev server / nginx 上，表现为一片莫名其妙的 404
 * （Request URL 长这样：http://localhost:9527/api/platform/rules）。
 * 改完 .env 必须重启 dev server —— vue-cli 只在启动时读一次 .env，热更新不会重读。
 */
if (!process.env.VUE_APP_BASE_API6) {
  // eslint-disable-next-line no-console
  console.error('[alliance] 未配置 VUE_APP_BASE_API6，联盟接口会打到前端自身导致 404。' + '请在 .env.development 配置后重启 dev server。当前 baseURL =', baseURL);
}

// ===================== 区域代理 =====================

/** 开通区域代理。该区已有生效代理时后端会拒绝，需走候补队列 */
function openRegionAgent(data) {
  return (0, _request.default)({
    url: '/api/platform/region/open',
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}

/** 查某区域当前生效代理 */
function getRegionAgent(regionCode) {
  return (0, _request.default)({
    url: '/api/platform/region/agent',
    method: 'get',
    params: {
      regionCode: regionCode
    },
    baseURL: baseURL
  });
}

/**
 * 全平台区域代理分页列表。
 *
 * regionPrefix 是行政区划编码前缀：'44' 查广东、'4401' 查广州、留空查全国。
 * 默认只出生效记录，includeInactive=true 才带上交接后的历史行。
 */
function getAgentList(params) {
  return (0, _request.default)({
    url: '/api/platform/region/agents',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/**
 * 编辑代理的合同信息与合作期。
 *
 * 刻意不能改 agentUid 和 regionCode：换人走 handoverRegionAgent（要校验待结算收益、
 * 开新的归属版本），在这里直接改人等于让一个人的历史业绩变成另一个人的。
 */
function updateRegionAgent(id, data) {
  return (0, _request.default)({
    url: "/api/platform/region/agent/".concat(id),
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}

/**
 * 按昵称 / 手机号 / uid 搜商城用户，开通代理时挑人用。
 *
 * 代理 uid 必须是真实存在的商城用户 —— 代理靠它登录小程序审批团长、看分成。
 * 让运营手打一个数字必然抄错，抄错就是一条没人能登录的空壳记录。
 */
function searchUser(keyword) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return (0, _request.default)({
    url: '/api/platform/user/search',
    method: 'get',
    params: {
      keyword: keyword,
      limit: limit
    },
    baseURL: baseURL
  });
}

/**
 * 按 uid 查用户，开通代理时确认「这个 uid 是谁」。
 *
 * 返回 valid=false 表示查无此人或账号已注销/禁用 —— 这种 uid 存进去就是一条
 * 没人能登录使用的空壳代理记录，前端必须拦住。
 */
function getUserBrief(uid) {
  return (0, _request.default)({
    url: '/api/platform/user/brief',
    method: 'get',
    params: {
      uid: uid
    },
    baseURL: baseURL
  });
}

/** 停用代理。软删：置失效并释放该区名额，历史分账记录仍能追溯到人 */
function disableRegionAgent(id, reason) {
  return (0, _request.default)({
    url: "/api/platform/region/agent/".concat(id, "/disable"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}

/** 删除没有绑定团长的区域代理（后端会再次校验团长数量） */
function deleteRegionAgent(id) {
  return (0, _request.default)({
    url: "/api/platform/region/agent/".concat(id, "/delete"),
    method: 'post',
    baseURL: baseURL
  });
}

/** 某区域的候补队列 */
function getRegionQueue(regionCode) {
  return (0, _request.default)({
    url: '/api/platform/region/queue',
    method: 'get',
    params: {
      regionCode: regionCode
    },
    baseURL: baseURL
  });
}

/** 从候补队列启用一位代理 */
function enableFromQueue(queueId, regionPath, qualification) {
  // 启用候补人走的是与平台招商同一个开通入口，所以同样要带资质（营业执照 + 法人身份证）
  return (0, _request.default)({
    url: "/api/platform/region/queue/".concat(queueId, "/enable"),
    method: 'post',
    params: {
      regionPath: regionPath
    },
    data: qualification || {},
    baseURL: baseURL
  });
}

/** 代理交接。现任有待结算收益时后端拒绝，必须先结清 */
function handoverRegionAgent(data) {
  return (0, _request.default)({
    url: '/api/platform/region/handover',
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}

/** 某区域的历史归属版本，用于追溯历史订单当时归谁管 */
function getRegionAssignments(regionCode) {
  return (0, _request.default)({
    url: '/api/platform/region/assignments',
    method: 'get',
    params: {
      regionCode: regionCode
    },
    baseURL: baseURL
  });
}

// ===================== 团长 =====================

/** 平台抽查否决代理的审批结果。只否决身份，不回溯已产生的分成 */
function vetoLeaderApply(applyId, reason) {
  return (0, _request.default)({
    url: "/api/platform/leader/apply/".concat(applyId, "/veto"),
    method: 'post',
    data: {
      reason: reason
    },
    baseURL: baseURL
  });
}

/** 给团长换代理。只改管理关系，不影响任何一单的分账 */
function changeLeaderAgent(leaderUid, newRegionCode, reason) {
  return (0, _request.default)({
    url: "/api/platform/leader/".concat(leaderUid, "/change-agent"),
    method: 'post',
    params: {
      newRegionCode: newRegionCode,
      reason: reason
    },
    baseURL: baseURL
  });
}

/** 解除团长与区域代理的管理绑定，保留团长身份及历史数据 */
function unbindLeaderAgent(leaderUid, reason) {
  return (0, _request.default)({
    url: "/api/platform/leader/".concat(leaderUid, "/unbind-agent"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}

// 佣金规则页已下线：地区维度下沉到商户端「淘客设置」的分地区奖励，
// 一件事不再有两处入口。后端 /api/platform/rules 仍在，只服务历史订单的
// ruleVersion 快照回溯，平台端不再提供维护界面。

// ===================== 风控 =====================

/** 待处理风险事件，按等级倒序，limit 上限 200 */
function getPendingRisks() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  return (0, _request.default)({
    url: '/api/platform/risk/pending',
    method: 'get',
    params: {
      limit: limit
    },
    baseURL: baseURL
  });
}

/** 处理风险事件。status：1-已拦截 2-审核中 3-确认风险 4-误报 5-已关闭 */
function handleRisk(id, status, remark) {
  return (0, _request.default)({
    url: "/api/platform/risk/".concat(id, "/handle"),
    method: 'post',
    params: {
      status: status,
      remark: remark
    },
    baseURL: baseURL
  });
}

// ===================== 配置 =====================

/** 全部联盟配置（key -> value 的字符串字典） */
function getAllianceConfig() {
  return (0, _request.default)({
    url: '/api/platform/config',
    method: 'get',
    baseURL: baseURL
  });
}

/** 更新单个配置并立即生效 */
function updateAllianceConfig(key, value) {
  return (0, _request.default)({
    url: '/api/platform/config',
    method: 'post',
    params: {
      key: key,
      value: value
    },
    baseURL: baseURL
  });
}

// ===================== 平台报表 =====================
//
// 以下六个都是「不限本人 / 不限本区」的全量查询，只有平台端能调。
// 代理端与团长端的同类接口一律带范围过滤，拿来做平台报表会少一大截数据。
//
// 统一返回 { total, list, users }：users 是 uid -> { nickname, phone, valid } 的字典，
// 后端一次性补齐，页面别再逐行去查用户。查不到的 uid 不在字典里，显示「查无此人」。

/**
 * 全平台团长分页。
 *
 * regionPrefix 是行政区划编码前缀；auditStatus：0-待审 1-通过 2-驳回。
 * 默认不限审批状态 —— 被驳回和被否决的那些也要看得见。
 */
function getLeaderList(params) {
  return (0, _request.default)({
    url: '/api/platform/leaders',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 全平台团长申请分页，含待抽查。抽查否决从这个列表选单 */
function getLeaderApplyList(params) {
  return (0, _request.default)({
    url: '/api/platform/leader/applies',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/**
 * 全平台分成明细分页。
 *
 * role：LEADER 团长 / AGENT 收货地区代 / AGENT_CITY 市代 / AGENT_PROVINCE 省代 /
 * AGENT_ORIGIN 招募代理 / DIRECT 直推奖励 / INDIRECT 间推奖励 / TEAM 团队奖励 /
 * REGION_BONUS 区域奖励。跨区订单里 AGENT 与 AGENT_ORIGIN 是两个不同的人，各占一行。
 */
function getCommissionList(params) {
  return (0, _request.default)({
    url: '/api/platform/commissions',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 团长提现申请：平台人工审核和确认打款 */
function getLeaderWithdrawList(params) {
  return (0, _request.default)({
    url: '/api/platform/withdrawals',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}
function approveLeaderWithdraw(id, remark) {
  return (0, _request.default)({
    url: "/api/platform/withdrawals/".concat(id, "/approve"),
    method: 'post',
    data: {
      remark: remark
    },
    baseURL: baseURL
  });
}
function rejectLeaderWithdraw(id, remark) {
  return (0, _request.default)({
    url: "/api/platform/withdrawals/".concat(id, "/reject"),
    method: 'post',
    data: {
      remark: remark
    },
    baseURL: baseURL
  });
}
function markLeaderWithdrawPaid(id, remark) {
  return (0, _request.default)({
    url: "/api/platform/withdrawals/".concat(id, "/paid"),
    method: 'post',
    data: {
      remark: remark
    },
    baseURL: baseURL
  });
}

// 自动打款已随 D26 删除：重试转账、查询转账状态两个接口后端已下线，
// 这里一并移除 —— 留着只会让人以为系统还能自己转账。

/**
 * 打款时才取的完整卡号。
 *
 * 列表里只有掩码，明文按笔单独取 —— 一次点开一笔，明文的暴露面就不是一整页。
 */
function getLeaderWithdrawCard(id) {
  return (0, _request.default)({
    url: "/api/platform/withdrawals/".concat(id, "/card"),
    method: 'get',
    baseURL: baseURL
  });
}

/** 积分账户分页，按可用余额倒序 */
function getPointsAccounts(params) {
  return (0, _request.default)({
    url: '/api/platform/points/accounts',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 积分账本分页。账本不可变，冲正是另写一行，所以按时间求和就是那段时间的净额 */
function getPointsLedger(params) {
  return (0, _request.default)({
    url: '/api/platform/points/ledger',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 同一团长对同一用户的每日积分核销次数、积分额度配置。0 表示不限。 */
function getLeaderUserVerifyLimitList(params) {
  return (0, _request.default)({
    url: '/api/platform/leader-user-verify-limits',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}
function saveLeaderUserVerifyLimit(data) {
  return (0, _request.default)({
    url: '/api/platform/leader-user-verify-limits',
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}
function disableLeaderUserVerifyLimit(id) {
  return (0, _request.default)({
    url: "/api/platform/leader-user-verify-limits/".concat(id, "/disable"),
    method: 'post',
    baseURL: baseURL
  });
}

/** 全平台核销单分页。merchantId 留空即查全平台 */
function getVerifyRecords(params) {
  return (0, _request.default)({
    url: '/api/platform/verify/records',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 指定商户的经营概览。商户端同名接口只能看自己 */
function getMerchantOverview(merchantId) {
  return (0, _request.default)({
    url: '/api/platform/merchant/overview',
    method: 'get',
    params: {
      merchantId: merchantId
    },
    baseURL: baseURL
  });
}

// ===================== 淘客设置（分享链路） =====================

// 平台端「淘客设置」页已作废：
//   · 开通条件目前不使用；
//   · 可分享商品池改由 eb_distribution_product 推导 —— 商户在商品库点「加入淘客」
//     就是把商品放进了分享池，不必让运营再勾一遍；
//   · 分享关系与代理利润分成归属挪到了商户端商品库的淘客设置弹窗
//     （仍是 eb_ca_config 里全平台共用的一份值，只是换了入口）。
// 后端 /api/platform/share/settings 保留，平台端不再调用。

// ===================== 淘客商品（全平台） =====================
//
// 走的是 admin 的 /admin/platform/**，不是联盟服务，所以不带 baseURL —— 它用默认的
// 商城后台地址。写在这个文件里只是因为菜单归在联盟下面，接口本身不属于联盟模块。

/** 全平台淘客商品分页，merId 留空为全部商户 */
function getPlatformDistributionProducts(params) {
  return (0, _request.default)({
    url: '/admin/platform/distribution/product/list',
    method: 'get',
    params: params
  });
}

/** 平台强制开关某条淘客商品配置。奖励值不给平台改，只给开关 */
function togglePlatformDistributionProduct(id, open) {
  return (0, _request.default)({
    url: "/admin/platform/distribution/product/toggle/".concat(id),
    method: 'post',
    params: {
      open: open
    }
  });
}

/** 淘客基础配置（eb_distribution_config）。merId 留空取平台级（0） */
function getDistributionConfig() {
  var merId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (0, _request.default)({
    url: '/admin/distribution/config/get',
    method: 'get',
    params: {
      merId: merId
    }
  });
}

/** 保存淘客基础配置。整条覆盖，所以调用方要把读回来的对象改完再传回去 */
function saveDistributionConfig(data) {
  return (0, _request.default)({
    url: '/admin/distribution/config/save',
    method: 'post',
    data: data
  });
}

// ===================== 成为团长的条件 =====================

/**
 * 条件规则列表。条件还没定下来，所以做成一行一条规则而不是几个写死的配置项：
 * 运营自由增删、改阈值、改文案，不用等发版。
 */
function getLeaderApplyRules() {
  return (0, _request.default)({
    url: '/api/platform/leader/apply/rules',
    method: 'get',
    baseURL: baseURL
  });
}

/** 可选指标清单。前端不维护副本 —— 后端加了指标这里自动就有，不会漏 */
function getLeaderApplyMetrics() {
  return (0, _request.default)({
    url: '/api/platform/leader/apply/metrics',
    method: 'get',
    baseURL: baseURL
  });
}
function saveLeaderApplyRule(data) {
  return (0, _request.default)({
    url: '/api/platform/leader/apply/rules',
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}
function deleteLeaderApplyRule(id) {
  return (0, _request.default)({
    url: "/api/platform/leader/apply/rules/".concat(id, "/delete"),
    method: 'post',
    baseURL: baseURL
  });
}

/** 某申请人当前的条件达标情况，供审批时参考。算的是此刻的值，不是提交时的快照 */
function getApplicantConditions(uid) {
  return (0, _request.default)({
    url: "/api/platform/leader/applies/".concat(uid, "/conditions"),
    method: 'get',
    baseURL: baseURL
  });
}

/** 平台代批一条申请。审批人仍记在该区代理名下，责任链与代理自己审批时一致 */
function approveLeaderApply(applyId) {
  return (0, _request.default)({
    url: "/api/platform/leader/applies/".concat(applyId, "/approve"),
    method: 'post',
    baseURL: baseURL
  });
}

/** 一键通过：把筛选出的待审申请全部批掉，返回实际通过条数 */
function approveAllLeaderApplies(regionPrefix) {
  return (0, _request.default)({
    url: '/api/platform/leader/applies/approve-all',
    method: 'post',
    params: {
      regionPrefix: regionPrefix
    },
    baseURL: baseURL
  });
}

/**
 * 分账账单-区域代理层。
 *
 * 一行一个代理，把辖下下线的消费、代理侧各角色的分成、辖区内的积分核销汇总在一起；
 * 金额按计佣时间归期，并按待结算/结算中/已入账/已失效拆开。
 */
function getAgentBills(params) {
  return (0, _request.default)({
    url: '/api/platform/bills/agents',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 分账账单-团长层。含名下成员消费与本人收款的积分核销 */
function getLeaderBills(params) {
  return (0, _request.default)({
    url: '/api/platform/bills/leaders',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 账单下钻：某个团长名下成员的消费明细 */
function getLeaderMemberConsume(leaderUid, params) {
  return (0, _request.default)({
    url: "/api/platform/bills/leaders/".concat(leaderUid, "/members"),
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/**
 * 分享追溯：一条分享链接从发出去到产生分成的全过程。
 *
 * 一行 = 一条分享链接。点击、绑定是分享自身的计数；成交与分成是顺着
 * 「点击 → 绑定 → 订单归因快照 → 分成明细」回溯出来的，金额直接取自
 * eb_distribution_order，后端不重算。
 *
 * 分成按结算状态（0-待结算 1-结算中 2-已入账 3-已失效）和受益角色各拆一份，
 * 财务据此区分已落袋与在途，以及团长侧 / 代理侧。
 */
function getShareTraces(params) {
  return (0, _request.default)({
    url: '/api/platform/share/traces',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 某条分享的点击与绑定明细。点了没绑的也返回，用来解释点击数与绑定数的差额 */
function getShareTraceConsumers(recordId, params) {
  return (0, _request.default)({
    url: "/api/platform/share/traces/".concat(recordId, "/consumers"),
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 某条分享带来的订单号；每笔分成的金额与结算状态仍到 getCommissionList 按单查 */
function getShareTraceOrders(recordId, params) {
  return (0, _request.default)({
    url: "/api/platform/share/traces/".concat(recordId, "/orders"),
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

// ===================== 淘客（第一批：申请与审核） =====================

/**
 * 淘客申请列表。status：0-待审核 1-已通过 2-已驳回，不传查全部。
 *
 * 身份证号后端只回脱敏值，列表和详情都拿不到明文 —— 这是有意的，不是接口漏字段。
 */
function getPromoterApplies(params) {
  return (0, _request.default)({
    url: '/api/platform/promoter/apply',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 通过申请，生成淘客身份与推广码 */
function approvePromoterApply(applyId) {
  return (0, _request.default)({
    url: "/api/platform/promoter/apply/".concat(applyId, "/approve"),
    method: 'post',
    baseURL: baseURL
  });
}

/**
 * 绿色通道一键通过：跳过条件判定直接批。
 *
 * 按钮权限单独控制（distribution:promoter:apply:quick），没有这个权限的账号看不到按钮；
 * 后端同样会把「走没走绿色通道、谁批的」记进申请单和身份变更流水。
 */
function quickApprovePromoterApply(applyId) {
  return (0, _request.default)({
    url: "/api/platform/promoter/apply/".concat(applyId, "/quick-approve"),
    method: 'post',
    baseURL: baseURL
  });
}

/** 驳回申请，必须写理由；用户改完可以重新提交，不限次数 */
function rejectPromoterApply(applyId, remark) {
  return (0, _request.default)({
    url: "/api/platform/promoter/apply/".concat(applyId, "/reject"),
    method: 'post',
    data: {
      remark: remark
    },
    baseURL: baseURL
  });
}

/** 停用淘客：只影响停用后支付成功的订单，在途分润照常结算 */
function disablePromoter(uid, reason) {
  return (0, _request.default)({
    url: "/api/platform/promoter/".concat(uid, "/disable"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}

/** 恢复淘客 */
function enablePromoter(uid, reason) {
  return (0, _request.default)({
    url: "/api/platform/promoter/".concat(uid, "/enable"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}

// ===================== 淘客管理（第二批） =====================

/** 淘客管理列表。status：1-在职 0-已停用，不传查全部 */
function getPromoters(params) {
  return (0, _request.default)({
    url: '/api/platform/promoter/list',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

// ===================== 团长授权（第二批，D20 授权制） =====================

/**
 * 平台授予团长资格，可指定城市与区域。
 *
 * 授予的是「资格」不是身份：用户拿到之后 app 才出现团长申请入口，
 * 提交门店资料、审核通过才真正成为团长。
 */
function grantLeader(data) {
  return (0, _request.default)({
    url: '/api/platform/leader/grant',
    method: 'post',
    data: data,
    baseURL: baseURL
  });
}

/** 授权列表。status：0-已授予待提交 1-已使用 2-已撤销 */
function getLeaderGrants(params) {
  return (0, _request.default)({
    url: '/api/platform/leader/grant',
    method: 'get',
    params: params,
    baseURL: baseURL
  });
}

/** 撤销还没被用掉的授权；已经成为团长的要走 revokeLeader */
function revokeLeaderGrant(grantId, reason) {
  return (0, _request.default)({
    url: "/api/platform/leader/grant/".concat(grantId, "/revoke"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}

/**
 * 收回团长身份。与「停用」不是一回事：收回会把身份退回被授予之前的那个
 * （原来是淘客就回淘客），在途分润照常结算，推广关系保留。
 */
function revokeLeaderIdentity(uid, reason) {
  return (0, _request.default)({
    url: "/api/platform/leader/".concat(uid, "/revoke"),
    method: 'post',
    params: {
      reason: reason
    },
    baseURL: baseURL
  });
}